<script setup>
const props = defineProps({
  type: {
    type: String,
    default: () => 'h2',
    validation: (value) => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
  }
})
</script>

<template>
  <h1 v-if="props.type === 'h1'" v-bind="$attrs" class="text-3xl font-bold text-gray-900">
    <slot></slot>
  </h1>
  <h2 v-if="props.type === 'h2'" v-bind="$attrs" class="text-3xl font-bold text-gray-900">
    <slot></slot>
  </h2>
  <h3 v-if="props.type === 'h3'" v-bind="$attrs" class="text-3xl font-bold text-gray-900">
    <slot></slot>
  </h3>
  <h4 v-if="props.type === 'h4'" v-bind="$attrs" class="text-3xl font-bold text-gray-900">
    <slot></slot>
  </h4>
  <h5 v-if="props.type === 'h5'" v-bind="$attrs" class="text-3xl font-bold text-gray-900">
    <slot></slot>
  </h5>
  <h6 v-if="props.type === 'h6'" v-bind="$attrs" class="text-3xl font-bold text-gray-900">
    <slot></slot>
  </h6>
</template>
